import React from 'react';
export function CapabilitiesGrid() {
  const integrations = ['WordPress', 'GA4', 'Google Search Console', 'HighLevel CRM', 'Social platforms', 'Email platforms', 'Call tracking', 'Conversation intelligence tools'];
  return <section id="integrations" className="w-full py-16 md:py-24 px-4" data-id="element-21">
      <div className="container max-w-5xl mx-auto" data-id="element-22">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-6 text-center leading-tight" data-id="element-23">
          Across SEO, Content, CRM, and RevOps
        </h2>

        <p className="text-lg text-muted-foreground text-center mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-24">
          WisePilot integrates with:
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-25">
          {integrations.map((integration, index) => <div key={index} className="bg-card rounded-lg p-4 border border-border text-center hover:shadow-md transition-shadow" data-id="element-26">
              <p className="text-sm font-medium text-foreground" data-id="element-27">
                {integration}
              </p>
            </div>)}
        </div>

        <div className="bg-[hsl(var(--brand-blue-light))]/5 dark:bg-[hsl(var(--brand-blue-dark))]/5 rounded-2xl p-8 border-2 border-[hsl(var(--brand-blue-light))] dark:border-[hsl(var(--brand-blue-dark))] text-center space-y-4" data-id="element-28">
          <p className="text-xl font-semibold text-foreground leading-relaxed" data-id="element-29">
            Your content strategy, publishing engine, and revenue tracking stop
            living in separate environments.
          </p>
          <p className="text-lg text-muted-foreground leading-relaxed" data-id="element-30">
            One system. One feedback loop. Continuous refinement.
          </p>
        </div>
      </div>
    </section>;
}